import FeatureFlagService from 'Services/FeatureFlags';
import { KUESKI_SESSION_STORAGE_KEY } from 'Src/consts/session';

import actionTypes from './actionTypes';

const setStateFromFeatureFlagService = (prevState = {}) => ({
  ...prevState,
  error: {
    errors: FeatureFlagService.errors,
    hasErrors: FeatureFlagService.hasErrors(),
  },
  providersReady: {
    ...FeatureFlagService.providersReady,
    isReady: FeatureFlagService.isReady,
  },
  ...FeatureFlagService.getAllFlags(),
});

const initialState = setStateFromFeatureFlagService();

const configReducer = (state, action) => new Promise((resolve) => {
  switch (action.type) {
    case actionTypes.REFRESH:
      if (localStorage.getItem(KUESKI_SESSION_STORAGE_KEY)) {
        FeatureFlagService
          .refreshFeatureFlags(action.payload ?? false)
          .then(() => resolve(setStateFromFeatureFlagService(state)));
      } else if (action.payload === true) {
        resolve(setStateFromFeatureFlagService(state));
      }
      break;
    default:
      resolve(state);
  }
});

export { configReducer, initialState };
